export const environment = {
  production: false,
  apiUrl: 'https://dev.api.bebidas.nigal.net',
};
